import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ErrorsComponent} from "./errors.component";
import {MatCardModule} from "@angular/material/card";
import {MatDividerModule} from "@angular/material/divider";

@NgModule({
    declarations: [ErrorsComponent],
    imports: [
        CommonModule,
        MatCardModule,
        MatDividerModule
    ],
    exports: [ErrorsComponent]
})
export class ErrorsModule {
}
